import { controls, grouped } from "../controls";
const bio_enrolments = {
  label: "Bio Enrolments",
  pageLabel: "Bio Enrolments", starting: true, url: "autogen",
  formActions: { edit: { allow: false }, delete: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "To Date", target: "to_date" }),
    ...controls.magicDate({ tab: "filter", name: "to_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Account" }),
    ...controls.oc({ tab: "filter", c: "Account", placeHolder: "Account Code", name: "BioEnrolment-account-account_code", fastpath: "accounts" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "BioEnrolment-account-account_display" }),
    ...controls.displayText({ tab: "filter", label: "Bio Enrolment Type" }),
    ...controls.oc({ tab: "filter", c: "BioEnrolmentType", placeHolder: "Bio Enrolment Type Code", name: "BioEnrolment-bio_enrolment_type-bio_enrolment_type_code", fastpath: "bio_enrolment_types" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "BioEnrolment-bio_enrolment_type-bio_enrolment_type_display" }),
    ...controls.displayText({ tab: "filter", label: "Vendor User Pkey", width: "col-sm-4", tag: "more" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "vendor_user_pkey", width: "col-sm-8", tag: "more", maxlength: 30 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Account", star: false }),
    ...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code", isRequired: false, fastpath: "accounts", isReadOnly: "edit" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "account_display" }),
    ...controls.displayText({ tab: "general", label: "Bio Enrolment Type", star: false }),
    ...controls.oc({ tab: "general", c: "BioEnrolmentType", placeHolder: "Bio Enrolment Type Code", name: "bio_enrolment_type_code", isRequired: false, fastpath: "bio_enrolment_types", isReadOnly: "edit" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "bio_enrolment_type_display" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Bio Enrolments",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Account Code", accessor: "BioEnrolment-account-account_code", },
      { Header: "First Name", accessor: "BioEnrolment-account-customer-individual_details-first_name", },
      { Header: "Bio Enrolment Type", accessor: "BioEnrolment-bio_enrolment_type-bio_enrolment_type_display", },
      { Header: "Photo Url", accessor: "photo_url", },
    ]
  }
};
export default bio_enrolments;